import { Component } from '@angular/core';
import { CostObject } from '../../../../../generated/generated-types';
import { GenericBaseModelDropDown } from '../../../../../shared/components/genericBaseModelDropDown';
import { CostObjectService } from '../../services/cost-object.service';

@Component({
  selector: 'app-cost-object-dropdown',
  template: '',
  standalone: true,
})
export class CostObjectDropdownComponent extends GenericBaseModelDropDown<CostObject> {

  constructor(
    private service: CostObjectService) {
    super(service, "CostObject");
  }

  // copyToClipboard(text: string) {
  //   this.clipboardService.copyFromContent(text);
  //   this.notificationService.success(_("common.copied-to-clipboard"), { entity: "company" });
  // }
}